module.exports = __webpack_public_path__ + "static/media/change-coin.e695c724.png";